import { useContext, useEffect } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { getAllNewPosts, getAllNewPostsPrev } from '../../../../../lib/service'
import { AboutBlog } from '../../../../../components/blogs/AboutBlog'
import { BlogHeaderLinks } from '../../../../../components/blogs/BlogHeaderLinks'

// This gets called on every request
export async function getServerSideProps({params, res}) {
    // Fetch data from external API
  
    console.log(params)
    const newBlogsData = await getAllNewPostsPrev(54, params.prevCursor); // retrieve first 100 posts
    const wpNewPosts = newBlogsData?.posts?.nodes
    const pageInfo = newBlogsData?.posts?.pageInfo
    
    
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=86400, stale-while-revalidate=59'
    )

    return {
        props: {
            wpNewPosts,
            pageInfo
        }
    }  
}

export default function Home(props) {
  const latestBlogs = []
  const wpPosts = []
  const wpNewPosts = props.wpNewPosts
  const pageInfo = props.pageInfo

  return (
    <>
      <Head>
        <title>Blogs on Previous Page | StringsSG Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Blog articles related to professional services in Singapore."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        {/* Cursor pages: any cursor value returns 200 with the same title - an unbounded set of near-duplicates. Followed for the post links, never indexed. */}
        <meta name="robots" content="noindex, follow"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/blogs" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Blogs | StringsSG"/>
        <meta property="og:description" content="Blog articles related to professional services in Singapore." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/blogs"/>
        <meta name="twitter:title" content="Blogs | StringsSG"/> 
        <meta name="twitter:description" content="Blog articles related to professional services in Singapore."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/blogs" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"WebSite","name":"Blogs","url":"https://www.stringssg.com/sg/blogs","potentialAction":{"@type":"SearchAction","target":"https://www.stringssg.com/sg/blogs?q={search_term_string}","query-input":"required name=search_term_string"}},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://www.stringssg.com/"},{"@type":"ListItem","position":2,"name":"blogs","item":"https://www.stringssg.com/sg/blogs"}]}]}`
          }}
        />
      </Head>
      <BlogHeaderLinks/>
      <div className='max-w-5xl mx-auto py-10'>
            <AboutBlog latestBlogs={latestBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts} pageInfo={pageInfo} pageNavigation={"prev"}/>
      </div>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
